export function Loading({ fullScreen = false }: { fullScreen?: boolean }) {
  const containerClass = fullScreen
    ? 'flex items-center justify-center min-h-screen'
    : 'flex items-center justify-center py-12';

  return (
    <div className={containerClass}>
      <div className="animate-spin rounded-full h-8 w-8 border-2 border-slate-200 border-t-[#00A871]" />
    </div>
  );
}

export default Loading;
